/**
 * Class to create an instance of KnexMigrator
 *
 * @class KnexMigrator
 * @extends {SqlMigrator}
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return KnexMigratorv2Tans;
    }
});
const _KnexMigratorv2 = /*#__PURE__*/ _interop_require_default(require("./KnexMigratorv2"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let KnexMigratorv2Tans = class KnexMigratorv2Tans extends _KnexMigratorv2.default {
    get metaDb() {
        return this.ncMeta.knex || _Noco.default.ncMeta.knex;
    }
    async getSqlClient(source) {
        return this.sqlClient || _NcConnectionMgrv2.default.getSqlClient(source);
    }
    constructor(context, base, sqlClient = null, ncMeta = _Noco.default.ncMeta){
        super(context, base);
        this.sqlClient = sqlClient;
        this.ncMeta = ncMeta;
    }
};
